import { Component, OnInit } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';

@Component({
    selector: 'app-animated-splash',
    templateUrl: './animated-splash.component.html',
    styleUrls: ['./animated-splash.component.scss'],
    standalone: false
})
export class AnimatedSplashComponent implements OnInit {
  public windowWidth: string;
  public showSplash = true;
  public hiding = false;
  constructor(private menuCtrl: MenuController) { }

  public ngOnInit(): void {
    // Splash is now hidden by parent via hideSplash()
  }

  public hideSplash(): void {
    this.hiding = true;
  }

  public onFadeComplete(): void {
    this.showSplash = false;
  }
  public ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  public ionViewWillUnload() {
    this.menuCtrl.enable(true);
  }

}
